import { render, staticRenderFns } from "./stock.vue?vue&type=template&id=9a5e5874&scoped=true"
import script from "./stock.vue?vue&type=script&lang=js"
export * from "./stock.vue?vue&type=script&lang=js"
import style0 from "./stock.vue?vue&type=style&index=0&id=9a5e5874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5e5874",
  null
  
)

export default component.exports